import { UserGroup } from '@round/api';

/**
 * Returns a function which tells if user matches group requirements.
 * @param userGroups - user's groups to test against
 * @returns userHasGroupAccess - A function which tells if user has access given groups to check against and matchType.
 */
export function makeUserHasGroupAccess(
    userGroups: UserGroup[]
): (groups: UserGroup[], hasAccessWhenMatches?: 'all' | 'any') => boolean {
    /**
     * @param groups - list of group requirements
     * @param matchType - check type.
     *  if 'all' is selected, then user groups should contain every group passed,
     *  if match type is 'any' then user should have at least one group from requirements
     */
    return (groups, hasAccessWhenMatches = 'all') => {
        const matches = groups.filter((group) => userGroups.includes(group));
        return hasAccessWhenMatches === 'all' ? matches.length === groups.length : matches.length > 0;
    };
}
